<template>
    <!-- Loading -->
    <div class="vld-parent">
        <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
    </div>

    <!-- Modal close -->
    <div class="w-full h-screen bg-transparent absolute top-0 left-0 right-0 z-40 cursor-default" v-show="(ProgexctimecommModal || detailModal || deleteModal)" @click="ProgexctimecommModal = false, detailModal = false, deleteModal = false"></div>

    <!-- Form Modal -->
    <vue-final-modal
    v-model="ProgexctimecommModal"
    classes="base-modal"
    :ssr="true"
    :content-class="darkMode ? 'add-modal bg-darkmode-base transition-colors duration-1000' : 'add-modal bg-gray-100 transition-colors duration-1000'"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
    >
    <!-- Modal Header -->
    <div class="modal-head">
        <h1 v-if="showEdit">{{ $t('progexctimecomm.editform') }}</h1>
        <h1 v-else>{{ $t('progexctimecomm.addform') }}</h1>

        <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="ProgexctimecommModal = false"
        />
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
        <progexctimecomm-form
        :prop-class="progexctimecommObject"
        :progexctime-id="programmeExceptionTimeId"
        :show-edit="showEdit"
        @close-modal="hideModal"
        @refresh-list="refresh"
        @reset-modal="resetModal"/>
    </div>
    </vue-final-modal>

    <!-- Detail Modal -->
    <vue-final-modal
    v-model="detailModal"
    classes="base-modal"
    :ssr="true"
    content-class="add-modal bg-gray-100 dark:bg-gray-700 transition-colors duration-1000"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
    >
    <!-- Modal Header -->
    <div class="modal-head">
        <h1>{{ $t('progexctimecomm.detail') }}</h1>
        <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="detailModal = false"
        />
    </div>

    <!-- Modal Content -->
    <div class="modal-content detail-content">
        <progexctimecomm-detail
        :prop-class="progexctimecommObject"
        @close-modal="hideModal"
        />
    </div>
    </vue-final-modal>

    <!-- Delete Modal -->
    <vue-final-modal
    v-model="deleteModal"
    classes="base-modal"
    :ssr="true"
    :content-class="darkMode ? 'delete-modal bg-darkmode-base transition-colors duration-1000' : 'delete-modal bg-gray-100 transition-colors duration-1000'"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false" transition="vfm" overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
    >
    <!-- Modal Header -->
    <div class="modal-head">
        <h1>{{ $t('menu.delete') }} {{ $t('menu.data') }}</h1>

        <jb-button class="btn-close-modal" :icon="mdiClose" @click="deleteModal = false"  />
    </div>

    <!-- Modal Content -->
    <div class="delete-content">
        <div class="warning">{{ $t('menu.warning') }}</div>

        <div class="messsage"><p>{{ $t('confirmDelete.message') }}</p></div>
    </div>

    <!-- Button action -->
    <div class="buttons-submit transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
        <jb-buttons class="buttons-action-submit">
        <jb-button :label="$t('finance.button.btnConfirm')" color="info" :icon="mdiTrashCan" @click="confirm" class="form-submit-btn" />
        <jb-button :label="$t('finance.button.btnCancel')" outline @click="cancel" class="btn-reset form-noicon-btn" />
        </jb-buttons>
    </div>
    </vue-final-modal>

    <!-- Main section -->
    <main-section class="overflow-x-hidden">

        <!-- Add button -->
        <jb-button label="Add" color="info" :icon="mdiPlusCircleOutline" small @click="addProgexctimecomm()" class="ml-4 w-auto px-8 py-2 md:hidden" />

        <!-- Table data -->
        <card-component class="relative mt-2 px-2 md:px-4 bg-white border border-gray-100 dark:bg-gray-900 dark:border-gray-600" :title="$t('progexctimecomm.title')" :icon="mdiCalendar" has-table>
            <jb-button
                label="Add"
                color="info"
                :icon="mdiPlusCircleOutline"
                small
                @click="addProgexctimecomm()"
                class="py-1 px-5 shadow-lg mt-1 w-auto absolute right-4 top-1 hidden md:flex"
            />
            <ag-grid-vue
                style="width: 100%; height: 70vh;"
                class="ag-theme-alpine"
                :defaultColDef="defaultColDef"
                :columnDefs="columnDefs"
                :pagination="true"
                :context="context"
                @grid-ready="onGridReady"
                :rowData="rowData.value">
            </ag-grid-vue>
        </card-component>
    </main-section>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import { onMounted, ref, reactive, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { mdiCalendar, mdiCircleEditOutline, mdiTrashCan, mdiPlusCircleOutline, mdiClose } from '@mdi/js'
import MainSection from '@/components/MainSection'
import JbButton from '@/components/JbButton'
import CardComponent from '@/components/CardComponent'
import { useToast } from 'vue-toastification'
import ProgexctimecommForm from '@/views/humanresource/programmeexceptiontimecommitee/ProgrammeExceptionTimeCommiteeForm'
import ProgexctimecommDetail from '@/views/humanresource/programmeexceptiontimecommitee/ProgrammeExceptionTimeCommiteeDetail'
import { AgGridVue } from 'ag-grid-vue3'
import { useI18n } from 'vue-i18n'
import ButtonActionRender from '@/components/ButtonActionRender'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
    components: {
        MainSection,
        Loading,
        CardComponent,
        ProgexctimecommForm,
        ProgexctimecommDetail,
        JbButton,
        AgGridVue,
        ButtonActionRender
    },
    props: {
        propClass: {
            type: Object,
            default: null
        },
        programmeExceptionTimeId: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const { t } = useI18n()
        const isLoading = ref(false)
        const rowData = reactive([])
        const filter = reactive({
            id: '',
            programme_exception_time_id: '',
            employee_id: '',
        })
        const store = useStore()
        const toast = useToast()
        const showEdit = ref(false)
        const detailModal = ref(false)
        const deleteModal = ref(false)
        const programmeExceptionTimeId = ref(props.programmeExceptionTimeId)
        const progexctimecommObject = ref({})
        const ProgexctimecommModal = ref(false)
        const isAsideMobileExpanded = computed(() => store.state.isAsideMobileExpanded)

        const columnDefs = [
            { headerName: '#', valueGetter: 'node.rowIndex+1', minWidth: 50 },
            { field: 'employee_name', headerName: t('progexctimecomm.employee_name'), sortable: true, filter: true, minWidth: 150 },
            { field: 'id', headerName: t('main.action'), sortable: true, filter: true, minWidth: 165, cellRenderer: 'ButtonActionRender' }
        ]

        const defaultColDef = { resizable: true }

        const refresh = async () => {
            isLoading.value = true
            const url = props.programmeExceptionTimeId ? `progexctimecomm?programme_exception_time_id=${props.programmeExceptionTimeId}` : 'progexctimecomm'
            await axios
                .get(url)
                .then(response => {
                    rowData.value = response.data.data
                    isLoading.value = false
                })
                .catch(error => {
                    toast.error(error.response?.data?.message || 'Failed to load data')
                    console.log(error)
                    isLoading.value = false
                })
        }

        watch(() => props.programmeExceptionTimeId, () => {
            refresh()
        })

        // const filteredRowData = computed(() => {
        //     if (!props.programmeExceptionTimeId) {
        //         return rowData.value
        //     } else {
        //         return rowData.value.filter(item => item.programme_exception_time_id === props.programmeExceptionTimeId)
        //     }
        // })

        onMounted(() => {
            refresh()
        })

        const hideModal = () => {
            ProgexctimecommModal.value = false
            detailModal.value = false
            refresh()
        }

        const showModal = () => {
            ProgexctimecommModal.value = !ProgexctimecommModal.value
        }

        const resetModal = () => {
            Object.assign(filter, {
                id: '',
                programme_exception_time_id: '',
                employee_id: ''
            })
        }

        const addProgexctimecomm = () => {
            showModal()
            resetModal()
            showEdit.value = false

            console.log('Sending ID to child:', props.programmeExceptionTimeId)

            progexctimecommObject.value = { ...filter }
            programmeExceptionTimeId.value = props.programmeExceptionTimeId
        }

        const detailData = (event, data )=> {
            progexctimecommObject.value = data
            detailModal.value = true
        }

        const editData = (event, data) => {
            showModal()
            progexctimecommObject.value = { ...data }
            programmeExceptionTimeId.value = props.programmeExceptionTimeId
            showEdit.value = true
        }

        const deleteModalShow = (value) => {
            deleteModal.value = true
            deleteModal.id = value
        }

        const confirmDelete = () => {
            axios
                .delete(`progexctimecomm/${deleteModal.id}`)
                .then(response => {
                    if (response.data.success) {
                        refresh()
                        toast.success(response.data.message)
                    } else {
                        toast.error(response.data.message)
                    }
                    deleteModal.value = false
                })
                .catch(error => {
                    toast.error(error.response?.data?.message || 'Failed to delete')
                    deleteModal.value = false
                })
        }

        return {
            isLoading,
            progexctimecommObject,
            showEdit,
            ProgexctimecommModal,
            addProgexctimecomm,
            hideModal,
            showModal,
            detailModal,
            detailData,
            editData,
            mdiCalendar,
            mdiClose,
            mdiCircleEditOutline,
            mdiTrashCan,
            mdiPlusCircleOutline,
            toast,
            refresh,
            rowData,
            filter,
            columnDefs,
            defaultColDef,
            t,
            gridApi: null,
            gridColumnApi: null,
            ButtonActionRender,
            deleteModal,
            deleteModalShow,
            confirm: () => confirmDelete(),
            cancel: () => deleteModal.value = false,
            resetModal,
            isAsideMobileExpanded
        }
    },
    beforeMount() {
        this.context = { componentParent: this }
    },
    methods: {
        onGridReady(params) {
            this.gridApi = params.api
            this.gridColumnApi = params.columnApi
            const allColumnIds = []
            this.gridColumnApi.getAllColumns().forEach((column) => {
                allColumnIds.push(column.colId)
            })
            this.gridColumnApi.autoSizeColumns(allColumnIds, false)
        }
    }
}
</script>